import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

export const MapMarkerNewConfirm = () => {
	const [sub, setSub] = useState("");
	const [subValues, setSubValues] = useState(localStorage.getItem("mapMarkerNotif"));

	useEffect(() => {
		const token = sessionStorage.getItem("accessToken");
		if (token) {
			const jwt = jwtDecode(token.replace("Bearer ", ""));
			setSub(jwt.sub ?? "");
		}
	}, []);

	const closeNotif = () => {
		let value = sub;
		if (subValues) {
			value = subValues + "," + sub;
		}
		localStorage.setItem("mapMarkerNotif", value);
		setSubValues(value);
	};

	if (!sub || subValues?.includes(sub)) {
		return <></>;
	}

	return (
		<div className="w-full flex items-start gap-4 rounded-md border border-[#FFE58F] bg-[#FFFBE6] px-6 py-5 text-sm">
			<InfoCircleOutlined className="text-[#FAAD14] text-2xl" />
			<div className="flex items-start">
				<p>Jūs varat pievienot objektus tabulā vai uz kartes. Jau pievienotiem objektiem var labot atrašanās vietu, tos pārvelkot uz kartes.</p>
				<button onClick={closeNotif} className="flex items-center">
					<CloseOutlined />
				</button>
			</div>
		</div>
	);
};
